var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEns(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 936,
    height: 500,
    viewBox: "0 0 936 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.423 163.173C144.492 157.476 148.92 152.619 154.319 149.031L244.912 86L152.088 238.931C152.088 238.931 143.978 225.275 140.814 218.365C136.873 209.677 134.885 200.236 134.99 190.702C135.095 181.168 137.291 171.772 141.423 163.173ZM104.034 268.669C105.057 283.294 109.204 297.532 116.198 310.43C123.191 323.329 132.87 334.589 144.586 343.458L244.79 413.075C244.79 413.075 182.096 323.054 129.217 233.477C123.863 224.013 120.264 213.666 118.592 202.931C117.852 198.07 117.852 193.125 118.592 188.264C117.213 190.81 114.537 196.022 114.537 196.022C109.175 206.917 105.523 218.568 103.709 230.568C102.665 243.252 102.774 256.004 104.034 268.669ZM359.512 280.79C356.267 273.881 348.238 260.224 348.238 260.224L255.577 413.075L346.17 350.084C351.568 346.496 355.997 341.64 359.066 335.943C363.198 327.343 365.393 317.947 365.499 308.414C365.604 298.88 363.616 289.438 359.674 280.75L359.512 280.79ZM396.292 230.446C395.269 215.822 391.122 201.583 384.129 188.685C377.135 175.787 367.456 164.526 355.74 155.658L255.698 86C255.698 86 318.351 176.021 371.272 265.598C376.611 275.065 380.196 285.412 381.856 296.144C382.596 301.005 382.596 305.95 381.856 310.811C383.235 308.265 385.911 303.053 385.911 303.053C391.273 292.158 394.925 280.507 396.738 268.507C397.796 255.824 397.701 243.072 396.455 230.406L396.292 230.446Z",
    fill: "url(#paint0_linear_2_10)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M562.454 318V291.74H500.642V258.612H556.596V233.766H500.642V201.042H562.454V174.782H472.766V318H562.454Z",
    fill: "url(#paint1_linear_2_10)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M711.954 318V174.782H684.078V269.52L624.489 174.782H589.745V318H617.62V216.394L682.664 318H711.954Z",
    fill: "url(#paint2_linear_2_10)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M842.14 208.92C838.908 192.76 825.576 171.752 790.832 171.752C763.764 171.752 740.938 191.144 740.938 216.596C740.938 238.21 755.684 252.956 778.51 257.602L798.508 261.642C809.618 263.864 815.88 270.328 815.88 278.61C815.88 288.71 807.598 296.184 792.65 296.184C772.45 296.184 762.552 283.458 761.34 269.318L735.484 276.186C737.706 296.588 754.472 321.03 792.448 321.03C825.778 321.03 844.16 298.81 844.16 276.792C844.16 256.592 830.222 239.624 804.164 234.574L784.166 230.736C773.662 228.716 768.612 222.454 768.612 214.576C768.612 205.082 777.5 196.396 791.034 196.396C809.214 196.396 815.678 208.718 817.092 216.596L842.14 208.92Z",
    fill: "url(#paint3_linear_2_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_10",
    x1: 596.675,
    y1: 451.839,
    x2: 422.077,
    y2: -244.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_10",
    x1: 596.675,
    y1: 451.839,
    x2: 422.077,
    y2: -244.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_10",
    x1: 596.675,
    y1: 451.839,
    x2: 422.077,
    y2: -244.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2_10",
    x1: 596.675,
    y1: 451.839,
    x2: 422.077,
    y2: -244.547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.378795,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.46adb737759f36d74f8efd9b73f05a62.svg";
export { ForwardRef as ReactComponent };